import { render, staticRenderFns } from "./scene.vue?vue&type=template&id=019ba7e8&scoped=true&"
import script from "./scene.vue?vue&type=script&lang=ts&"
export * from "./scene.vue?vue&type=script&lang=ts&"
import style0 from "./scene.vue?vue&type=style&index=0&id=019ba7e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019ba7e8",
  null
  
)

export default component.exports